/* ASH backgrounds and ZOOM hover eligibility for saved/fetched product cards. */
(function () {
  'use strict';

  var productRequests = new Map();

  function hasTag(tags, expectedTag) {
    var values = Array.isArray(tags) ? tags : String(tags || '').split(',');
    return values.some(function (tag) {
      return String(tag).trim().toUpperCase() === expectedTag;
    });
  }

  function isAsh(tags) {
    return hasTag(tags, 'ASH');
  }

  function isZoom(tags) {
    return hasTag(tags, 'ZOOM');
  }

  function productEndpoint(link) {
    try {
      var productUrl = new URL(link.getAttribute('href'), window.location.origin);
      if (productUrl.origin !== window.location.origin) return null;
      var match = productUrl.pathname.match(/\/products\/([^/]+)\/?$/);
      if (!match) return null;
      var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      var endpoint = new URL(shopRoot + 'products/' + match[1] + '.js', window.location.origin);
      return endpoint.origin === window.location.origin ? endpoint.href : null;
    } catch (error) {
      return null;
    }
  }

  function getProduct(endpoint) {
    if (!productRequests.has(endpoint)) {
      // Shopify Ajax Product API: https://shopify.dev/docs/api/ajax/reference/product
      var request = fetch(endpoint, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        })
        .catch(function () {
          productRequests.delete(endpoint);
          return null;
        });
      productRequests.set(endpoint, request);
    }
    return productRequests.get(endpoint);
  }

  function refreshWishlist(container) {
    if (!container) return Promise.resolve([]);
    var jobs = Array.from(container.querySelectorAll('.wishlist-item')).map(function (card) {
      var link = card.querySelector('.wishlist-item-title a');
      var endpoint = link && productEndpoint(link);
      if (!endpoint) return Promise.resolve();
      return getProduct(endpoint).then(function (product) {
        if (product && card.isConnected !== false) {
          card.classList.toggle('eyemode-card--ash', isAsh(product.tags));
          var zoomEnabled = isZoom(product.tags);
          card.classList.toggle('eyemode-card--zoom', zoomEnabled);
          if (zoomEnabled && product.images && product.images[1]) {
            card.setAttribute('data-eyemode-hover-src', product.images[1]);
          } else {
            card.removeAttribute('data-eyemode-hover-src');
          }
        }
      });
    });
    return Promise.all(jobs);
  }

  window.EyemodeCardBackgrounds = {
    isAsh: isAsh,
    isZoom: isZoom,
    refreshWishlist: refreshWishlist
  };
}());
